<template>
  <v-container fluid grid-list-xs fill-height>
    <v-layout column warp>
      <template>
        <v-card-title>
          Provider List
          <v-spacer />
          <v-text-field
            v-on:input="debounceInput"
            :value="search"
            clearable
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': rowsPerPageItems }"
          :options.sync="pagination"
          :server-items-length="totalProviders"
          :headers="headers"
          :items="providers"
          :loading="loading"
          item-key="id"
          class="elevation-1 full-width full-height"
        >
          <v-progress-linear v-slot:progress color="blue" indeterminate />
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.name"
                v-on:dblclick="viewProfile(item.id)"
                :style="{ cursor: 'pointer' }"
              >
                <td class="text-center">
                  {{ item.id }}
                </td>
                <td class="px-2 py-3">
                  <v-flex align-center justify-center layout text-center>
                    <v-tooltip right :color="item.approved ? 'success' : 'error'">
                      <template v-slot:activator="{ on }">
                        <v-badge overlap bottom :color="item.approved ? 'success' : 'error'">
                          <template v-slot:badge>
                            <v-icon v-on="on" dark slot="badge">{{ item.approved ? 'done_outline' : 'close' }}</v-icon>
                          </template>
                          <v-avatar v-on="on" :tile="false" :size="90" color="grey lighten-4" class="elevation-5">
                            <img v-if="item.avatar" :src="item.avatar" class="cover" alt="" srcset="" />
                            <v-icon v-else color="grey" :size="90">person</v-icon>
                          </v-avatar>
                        </v-badge>
                      </template>
                      <span>{{ item.approved ? 'Approved' : 'Not yet approve' }}</span>
                    </v-tooltip>
                  </v-flex>
                </td>
                <td class="text-center">{{ item.fullName }}<br />({{ providerType(item) }})</td>
                <td class="text-center" v-html="providerContact(item)"></td>
                <td class="text-center">
                  <v-icon :size="30" v-if="item.hidden" style="color: red">visibility_off</v-icon>
                  <v-icon :size="30" v-else>visibility</v-icon>
                </td>
                <td class="text-center">
                  <div :title="item.performance">
                    {{ item.level ? item.level : '-' }}
                  </div>
                </td>
                <td class="text-center">
                  {{ item.allowDonation ? 'Yes' : 'No' }}
                </td>
                <td class="px-0 py-1">
                  <v-flex align-center justify-center layout text-center>
                    <v-menu open-on-hover auto offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" color="secondary"> Action </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="viewProfile(item.id)">
                          <v-list-item-title>View Profile</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="archived(item)">
                          <v-list-item-title>Archive</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!item.approved" @click="approved(item)">
                          <v-list-item-title>Approve</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-flex>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
/*eslint-disable no-unused-vars*/
import { Vue } from 'vue-property-decorator';
import store from '../../store';
import provider from '../../services/providerProfiles';
import { providerMixin } from '../../transformers/providerProfile';
import arrUtil from '../../utils/arrayUtil';
import tableMixin from '../../Mixins/table';
import { debounce } from 'lodash';

export default Vue.extend({
  store,
  mixins: [providerMixin, tableMixin],
  data: () => ({
    loading: false,
    search: '',
    itemsAction: [
      {
        title: 'View Profile',
      },
      {
        title: 'Archived',
      },
    ],
    providers: [],
    totalProviders: 0,
    pagination: {},
    headers: [
      {
        text: 'Provider ID',
        align: 'center',
        value: 'id',
        sortable: true,
      },
      {
        text: 'Picture',
        align: 'center',
        value: 'tel',
        sortable: false,
      },
      {
        text: 'Name',
        align: 'center',
        value: 'fullName',
        sortable: false,
      },
      {
        text: 'Contact',
        align: 'center',
        value: 'email',
        sortable: false,
      },
      {
        text: 'Visibility',
        align: 'center',
        value: 'hidden',
        sortable: false,
      },
      {
        text: 'Level',
        align: 'center',
        value: 'level',
        sortable: false,
      },
      {
        text: 'Allow Donation',
        align: 'center',
        value: 'allowDonation',
        sortable: false,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'id',
        sortable: false,
      },
    ],
  }),
  computed: {
    user() {
      return store.state.auth.user;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getProviderList().then((data) => {
          this.providers = data.items;
          this.totalProviders = data.total;
        });
      },
      deep: true,
    },
    search() {
      this.getProviderList().then((data) => {
        this.providers = data.items;
        this.totalProviders = data.total;
      });
    },
  },
  created() {},
  mounted() {
    this.getProviderList().then((data) => {
      console.log(data);
      this.providers = data.items;
      this.totalProviders = data.total;
    });
  },
  methods: {
    getProviderList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;

        let query = {};
        query.archived = false;
        if (itemsPerPage !== -1) {
          query.per_page = itemsPerPage;
          query.page = page;
        } else {
          if (this.totalProviders) {
            query.per_page = this.totalProviders;
            query.page = 1;
          }
        }

        if (sortBy.length > 0) {
          // Support only one field sort
          query.order = sortBy[0];
          query.sort = sortDesc[0] ? 'desc' : 'asc';
        }

        if (this.search) query.q = this.search;

        provider
          .all(query)
          .then((data) => {
            const items = data.data;
            const total = data.pagination.total;
            this.loading = false;
            resolve({
              items,
              total,
            });
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
    viewProfile(id) {
      window.router.push({
        name: 'providerProfile',
        params: {
          id: id,
        },
      });
    },
    archived(one) {
      this.$root
        .$confirm('Archive', `Are you sure for archive <b>${this.providerName(one)}</b> ?`, {
          color: 'primary',
          submitText: 'archive',
        })
        .then((confirm) => {
          if (confirm) {
            const archiveObj = {
              archived: true,
              hidden: true,
            };
            provider.newEdit(one.id, archiveObj).then((data) => {
              this.providers = window._.reject(this.providers, {
                id: data.id,
              });
              this.$notify({
                title: 'Archived',
                text: `Archived ${this.providerName(one)} success !!`,
                type: 'success',
              });
            });
          }
        });
    },
    approved(one) {
      this.$root
        .$confirm('Approve', `Are you sure for approve <b>${this.providerName(one)}</b> ?`, {
          color: 'red',
          submitText: 'Approve',
        })
        .then((confirm) => {
          if (confirm) {
            provider.newEdit(one.id, { approved: true }).then((data) => {
              this.providers = arrUtil.searchByIdentityAndChangeAnyValue(
                this.providers,
                {
                  id: data.id,
                },
                data
              );
              this.$notify({
                title: 'Approve',
                text: `Approve ${this.providerName(one)} success !!`,
                type: 'success',
              });
            });
          }
        });
    },
    debounceInput: debounce(function (e) {
      this.search = e;
    }, 500),
  },
  components: {},
});
</script>

<style scoped>
.cover {
  object-fit: cover;
}
</style>
